import type { QueryClient } from "@tanstack/vue-query";
import type { MaybeRef } from "vue";

export async function fetchSingleFileById(id: string) {
  const { data } = await useGetRequest<{ path: string }>("/account/files", {
    params: {
      id,
    },
  });
  if (data.path) {
    data.path = data.path.replace("/files/", "/files/mediaAssets/");
  }
  return data || null;
}

export function useSingleFileRequest(id: MaybeRef<string>, disabled?: MaybeRef<boolean>) {
  const enabled = computed(() => {
    return !!toValue(id) && !toValue(disabled);
  });
  const request = useQuery({
    queryKey: ["files", "single", id],
    queryFn: () => fetchSingleFileById(toValue(id)),
    staleTime: 3 * MINUTE,
    enabled,
  });
  return request;
}

export function prefetchSingleFileById(id: string, queryClient: QueryClient) {
  queryClient.prefetchQuery({
    queryKey: ["files", "single", id],
    queryFn: () => fetchSingleFileById(id),
  });
}
